import {HelperFunctions} from "../../config/helperFunctions";
import {doStyleOnAllOrderingPages} from "../../blocks/allOrderingProcess";
import {doStyleProductFlags, doStyleProductsListing} from "../../blocks/productsListing";
import {STATES} from "../../config/states";

export class CartFirstStep {
    static EventListeners = {
        'ShoptetDOMContentLoaded': CartFirstStep.doLoadOnShoptetDOMPageContentLoaded,
        'ShoptetCartUpdated': CartFirstStep.doLoadOnShoptetDOMCartContentLoaded,
        'ShoptetDOMCartContentLoaded': CartFirstStep.doLoadOnShoptetDOMCartContentLoaded,
    }

    static doLoadOnShoptetDOMCartContentLoaded() {
        CartFirstStep.doFixImageSizes();
    }
    static doLoadOnShoptetDOMPageContentLoaded() {
        doStyleOnAllOrderingPages();
        CartFirstStep.doStyleCartMisc();
        CartFirstStep.doFixImageSizes();
    }
    // static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    // static doLoadOnShoptetDOMContentLoaded() {}
    static doLoadShoptetCartUpdated() {
    }
    static async doInit() {
        doStyleOnAllOrderingPages();
        CartFirstStep.doStyleCartMisc();
        CartFirstStep.doFixImageSizes();
        doStyleProductsListing();
        doStyleProductFlags();
        return true;
    }

    static doStyleCartMisc() {
    }

    static doFixImageSizes() {
        // fix img sizes
        $('body').addClass('in-kosik');

        HelperFunctions.waitForElement('.cart-table td.cart-p-image img').then(() => {
            $(".cart-table td.cart-p-image img").each(function (index, element) {
                HelperFunctions.doReplaceImageSourceAttributes(element, "/related/", "/detail/");
            });
        });
    }
}
